import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useCallback, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import { setAlert } from 'actions/alerts';
import useUploadMindsetMeetingTranscript from 'actions/mindset/useUploadMindsetMeetingTranscript';
import SimpleModal from 'components/SimpleModal';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import DropIndicator from 'components/DropIndicator';
import Spinner from 'components/Spinner';
import Stack from 'components/Stack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ACCEPTED_FILE_TYPES = '.pdf,.doc,.docx,.vtt,.srt,.txt';
var OpenLink = function OpenLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(TextLink, {
    as: "span",
    children: children
  });
};
function MindsetUploadMeetingTranscriptModal(_ref2) {
  var onClose = _ref2.onClose,
    onUpload = _ref2.onUpload;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    file = _useState2[0],
    setFile = _useState2[1];
  var _useState3 = useState('idle'),
    _useState4 = _slicedToArray(_useState3, 2),
    stage = _useState4[0],
    setStage = _useState4[1];
  var _useUploadMindsetMeet = useUploadMindsetMeetingTranscript(),
    uploadTranscript = _useUploadMindsetMeet.mutateAsync,
    isPending = _useUploadMindsetMeet.isPending;
  var selectFile = useCallback(function (acceptedFiles, rejectedFiles) {
    if (rejectedFiles.length) {
      setAlert({
        title: "".concat(t('error_uploading_file'), ": ").concat(rejectedFiles[0].name)
      });
      return;
    }
    if (acceptedFiles.length) {
      setFile(acceptedFiles[0]);
    }
  }, [t]);
  var _useDropzone = useDropzone({
      multiple: false,
      accept: ACCEPTED_FILE_TYPES,
      onDrop: selectFile,
      disabled: isPending
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragReject = _useDropzone.isDragReject;
  var handleUpload = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var initialAnalysis, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (file) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return");
        case 1:
          setStage('uploading');
          _context.prev = 2;
          _context.next = 3;
          return uploadTranscript({
            file: file,
            onUploaded: function onUploaded() {
              return setStage('processing');
            }
          });
        case 3:
          initialAnalysis = _context.sent;
          _context.next = 5;
          break;
        case 4:
          _context.prev = 4;
          _t = _context["catch"](2);
          // Error alert is already shown by useUploadMeetingMindsetTranscript's
          // onError - keep the modal open so the user can retry.
          setStage('idle');
          return _context.abrupt("return");
        case 5:
          onUpload === null || onUpload === void 0 || onUpload(file, initialAnalysis);
          onClose();
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 4]]);
  })), [file, uploadTranscript, onUpload, onClose]);
  var dropContent;
  if (stage !== 'idle') {
    dropContent = /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsx(Spinner, {}), /*#__PURE__*/_jsx(Text, {
        bold: true,
        children: stage === 'uploading' ? t('content_uploading_transcript') : t('content_processing_transcript')
      })]
    });
  } else if (file) {
    dropContent = /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsx(Text, {
        bold: true,
        children: file.name
      }), /*#__PURE__*/_jsxs(Trans, {
        t: t,
        i18nKey: "modal_upload_meeting_transcript_cta",
        children: [/*#__PURE__*/_jsx(OpenLink, {
          children: "Click"
        }), " or drag and drop to replace file"]
      })]
    });
  } else {
    dropContent = /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsxs(Trans, {
        t: t,
        i18nKey: "modal_upload_meeting_transcript_message_1",
        children: [/*#__PURE__*/_jsx(OpenLink, {
          children: "Click"
        }), " or drag and drop to upload a meeting transcript file."]
      }), t('modal_upload_meeting_transcript_message_2')]
    });
  }
  return /*#__PURE__*/_jsx(SimpleModal, {
    id: "mindset-upload-modal",
    title: t('modal_upload_meeting_transcript_title'),
    onClose: onClose,
    body: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, getRootProps()), {}, {
      children: /*#__PURE__*/_jsxs(Text, {
        as: "div",
        size: "s",
        children: [/*#__PURE__*/_jsx("input", _objectSpread({}, getInputProps())), /*#__PURE__*/_jsx(DropIndicator, {
          textAlign: "center",
          p: "xs",
          background: "shaded",
          isDragActive: isDragActive,
          isDragReject: isDragReject,
          children: dropContent
        })]
      })
    })),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onClose,
      isDisabled: isPending
    }, {
      label: t('actions_upload'),
      variant: 'primary',
      isDisabled: !file || isPending,
      onClick: handleUpload
    }]
  });
}
export default MindsetUploadMeetingTranscriptModal;